
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw } from '../../lib'
// import AsideBar from './AsideBar'

import './info-call.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
import ComplianceHits from './ComplianceHits'
import ComplianceImprovents from './ComplianceImprovents'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function ProjectDashboard(props) {
    const { data } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(data)

    const getProjectId = () => {
        if (data.isGeneralDashboard) {
            return 1;
        } else {
            return data.id_proyect;
        }
    }
   
    const projectId = getProjectId();
    const url = projectId ? 
        `${process.env.REACT_APP_DASHBOARD}/?id=${data.id}&id_proyect=${projectId}&type=studio` :
        null;
    
        console.log('url==========', url)

    useEffect(() => {
        setCall(data)
    }, [data])

    if (!url) {
        return (
            <div className="info-call w-full" style={{ backgroundColor: 'white', paddingTop: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                <div style={{ textAlign: 'center' }}>
                    <h3>Dashboard no available</h3>
                    <p>The dashboard could not be loaded. Invalid project information..</p>
                </div>
            </div>
        );
    }

    return (

        <>
            <div class="info-call w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}  >
                <iframe 
                    src={url}  
                    style={{width: '100%', height: '100%'}}
                    title={data.isGeneralDashboard ? "General Dashboard" : "Project Dashboard"}
                >
                </iframe>
                {/* <div class="info-call-item fotter">
                    <app-fotter-info-call></app-fotter-info-call>
                </div> */}
            </div>
            {/* <div>
                <div class="container_error_image">
                    <h2>Sorry !</h2>
                    <h6>
                        {{ message }}
                    </h6>
                </div>
                <div class="item-close" *ngIf="showRetry">
                <button (click)="retryAssesment()">
                Retry
            </button>
        </div> */}



        </>


    )
}
